import imageDe from '../images/de/sensotrend_signin_check_email.png';
import imageEn from '../images/en/sensotrend_signin_check_email.png';
import imageEs from '../images/es/sensotrend_signin_check_email.png';
import imageFi from '../images/fi/sensotrend_signin_check_email.png';
import imageFr from '../images/fr/sensotrend_signin_check_email.png';
import imageIt from '../images/it/sensotrend_signin_check_email.png';
import imageNo from '../images/no/sensotrend_signin_check_email.png';
import imageSv from '../images/sv/sensotrend_signin_check_email.png';

export const checkEmailImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
